import { AuthContext } from '@repo-level/core-front';
import { localStorageEmail } from 'helpers/common';
import { useContext, useEffect } from 'react';

export const useStoredLoginEmailSync = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.email) return;
    if (localStorageEmail.get() === user.email) return;

    localStorageEmail.replace(user.email);
  }, [user?.email]);
};
